import { render } from "./FactorItem.vue?vue&type=template&id=2da9b418&scoped=true&ts=true"
import script from "./FactorItem.vue?vue&type=script&lang=ts"
export * from "./FactorItem.vue?vue&type=script&lang=ts"

import "./FactorItem.vue?vue&type=style&index=0&id=2da9b418&scoped=true&lang=css"

import exportComponent from "E:\\operationmanualNew\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2da9b418"]])

export default __exports__